<template>
  <div
    :class="{
      [$style.footer]: true,
      [$style.footerFullWidth]: settings.isContentNoMaxWidth,
    }"
  >
    <div :class="$style.inner">
      <div class="row">
        <div class="col-md-12">
          <div class="logo-rodape" :class="$style.logo">
            <a href="https://acquire.solutions" title="Acquire - Plataforma Para Gestão de Recebíveis!" target="_blank">
              <img src="resources/images/logo.png" alt="Acquire Solutions" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import AcquireCopyright from "./copy.vue";

const LOGO_BASE = "resources/images/logo.png";
export default {
  components: {
   
  },
  computed: {
    ...mapGetters({
      getConfig: "getConfig",
    }),
    ...mapState(["settings"]),
    year() {
      return new Date().getFullYear();
    },
    logo() {
      try {
        return this.getConfig.logo || LOGO_BASE;
      } catch (e) {
        return LOGO_BASE;
      }
    },
    nomeSaleChannel() {
      return this.getConfig.name || "";
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<style lang="scss" scoped>
.logo-rodape {
  padding: 0;
  img {
    max-width: 100px !important  ;
  }
}
</style>
